<template>
  <div style="position:relative; width:100%;">
    <StatusSegment style="float:left;"
      v-for="status in Statuses" :key="status.CurrentItemsState"
      :CurrentItemsState="status.CurrentItemsState"
      :CurrentItemsCount="status.CurrentItemsCount"
      :TotalItems="status.TotalItems"
      :CssSuffix="status.ClassSuffix"
      :Width="15"
      :ToolTip="status.ToolTip"
      :CurrentItemName="status.CurrentItemsState"
      :ShowNumbers="ShowNumbers">
    </StatusSegment>
  </div>
</template>
<script>
import StatusSegment from "@/views/components/atoms/StatusSegment.vue";

export default {
  props: ["Statuses", "ShowNumbers"],
  components: {
    StatusSegment,
  },
};
</script>
